import TransactionService from '@/services/transaction'

export default {
  getProduct ({commit}, type) {
    const products = zis.find(item => item.id == type).products
    if (products) {
      return Promise.resolve(products)
    }

    return Promise.resolve([])
  },
  setTransactionProduct ({commit}, data) {
    commit('SET_TRANSACTION_PRODUCT', data)
    return Promise.resolve(data)
  },
  setTransactionPayment ({commit}, data) {
    commit('SET_TRANSACTION_PAYMENT', data)
  },
  getTypeTransaction ({commit}, params = {}) {
    return new Promise((resolve, reject) => {
      TransactionService.getTypeTransaction({
        params,
        headers: {
          'Authorization': localStorage.token
        }
      })
        .then(response => {
          commit('SET_TYPE_TRANSACTION', response.data.data)
          resolve(response.data.data)
        })
        .catch(e => reject(e))
    })
  },
  makeTransaction ({commit}, payload = {}) {
    return new Promise((resolve, reject) => {
      TransactionService.makeTransaction(payload, {
        headers: {
          'Authorization': localStorage.token
        }
      })
        .then(response => {
          commit('SET_HISTORY_TRANSACTION', response.data)
          resolve(response.data)
        })
        .catch(e => reject(e))
    })
  },
  deleteTransactionProduct({commit}) {
    commit('DELETE_TRANSACTION_PRODUCT')
  },
  deleteTransactionPayment({commit}) {
    commit('DELETE_TRANSACTION_PAYMENT')
  },
  deleteTransactionAmount({commit}) {
    commit('DELETE_TRANSACTION_AMOUNT')
  },
  deleteTransactionTypes({commit}) {
    commit('DELETE_TRANSACTION_TYPES')
  },
  deleteTransactionHistory({commit}) {
    commit('DELETE_TRANSACTION_HISTORY')
  }
}